import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '../../../hooks/@lore/query-connect';
import ReminderDialogTemplate from '../_common_reminders/ReminderDialogTemplate';

Dialog.propTypes = {
  project: PropTypes.object.isRequired
};

export default function Dialog(props) {
  const { project } = props;

  const reminders = useConnect('reminder.find', {
    where: {
      eager: {
        $where: {
          projectId: project.id,
          type: {
            $in: [
              'Close'
            ]
          }
        }
      }
    }
  });

  const creator = useConnect('user.byId', {
    id: project.data.creatorId
  });

  let _data = {
    type: 'Close',
    projectId: project.id,
    recipientId: project.data.creatorId
  };

  return (
    <ReminderDialogTemplate
      title="Send reminder to close project"
      subtitle={(
        <span>
          This will send an email to {creator.data.firstName} nudging them to close their project.
        </span>
      )}
      reminders={reminders}
      _data={_data}
      blockerText={(
        project.data.completed ||
        project.data.cancelled
      ) && (
        <div className="text-base text-cs-gray-700">
          Project has already been closed. Sending a reminder is not allowed.
        </div>
      )}
      MAX_COUNT={3}
      onClose={props.onClose}
    />
  );
};
